import Base from './Base';

const ENTITY = 'news';
export const REDUCER_NAME = ENTITY;

const initialState = { isFetching: true, isSingleObject: true, values: {} };
const news = new Base(ENTITY, initialState);

export const reducer = news.reducer.bind(news);
news.getAsync.bind(news);

export const get = () => {
  return news.getAsync(`${ENTITY}`);
};



// WEBPACK FOOTER //
// ./src/redux/modules/news.js